export default __webpack_public_path__ + "5e2e3e7d4847f53e1084826c35c0e84b.svg";